import { createSlice } from "@reduxjs/toolkit";
import {
  deleteBloodGroup,
  getBloodGroup,
  undoDeleteBloodGroup,
} from "./bloodGroup.api";

const bloodGroupSlice = createSlice({
  name: "bloodGroup",
  initialState: {
    bloodGroup: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBloodGroup.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getBloodGroup.fulfilled, (state, action) => {
      state.loading = false;
      state.bloodGroup = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getBloodGroup.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteBloodGroup.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteBloodGroup.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.bloodGroup.data) {
        state.bloodGroup.data = state.bloodGroup.data.filter((bloodGroup) => {
          return bloodGroup._id !== deletedId;
        });
        state.loading = false;
      } else {
        console.error(
          "state.bloodGroup.data is not an array:",
          state.bloodGroup.data
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteBloodGroup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteBloodGroup.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteBloodGroup.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.bloodGroup.data) {
        state.bloodGroup.data = state.bloodGroup.data.filter((bloodGroup) => {
          return bloodGroup._id !== undodeletedId;
        });
        state.loading = false;
      } else {
        console.error(
          "state.bloodGroup.data is not an array:",
          state.bloodGroup.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteBloodGroup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = bloodGroupSlice.actions;
export default bloodGroupSlice.reducer;
